import { IAnimationElementProps } from '../../../../../common/Animation';

export const serviceErrorAnimationConfig: IAnimationElementProps = {
  variants: {
    start: {
      rotate: [0, 1, -1, 0],
      transition: {
        duration: 0.1,
        delay: 0.3,
        repeat: 4,
      },
    },
    reset: {
      rotate: 0,
    },
  },
};
